import { InputWrapperSharedProps } from '../components/InputWrapper/InputWrapper';

interface GetPlaceholderParams extends InputWrapperSharedProps {
    isDropdown?: boolean;
}

export function getPlaceholder(params: GetPlaceholderParams): string {
    const { placeholder, label, bulkMode, isDropdown } = params;
    const bulkHandler = bulkMode ? '<Mixed>' : placeholder || '';
    if (bulkHandler) {
        return bulkHandler;
    }

    if (label && typeof label === 'string') {
        if (isDropdown) {
            return `Choose ${label}`;
        } else {
            return `Enter ${label}`;
        }
    }

    return '';
}
